import { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client/react';

import { isFilterableDataType } from '@atom/components/common/workOrdersFilters/fieldFilterUtilities';
import WorkOrderFieldFilterInput from '@atom/components/common/workOrdersFilters/WorkOrderFieldFilterInput';
import WorkOrdersContext, {
  WorkOrdersInputActionTypes,
} from '@atom/components/workOrders/WorkOrdersContext';
import { GET_WORK_ORDER_TEMPLATE } from '@atom/graph/workTemplate';
import { FieldFilter, WorkOrderField } from '@atom/types/work';
import { isCascadingField } from '@atom/utilities/workOrderFieldUtilities';

import classes from './workOrdersFilters.module.css';

const WorkOrdersWorkFieldsFilter = () => {
  const { workOrdersInputCart, filtersDisabled, dispatch } =
    useContext(WorkOrdersContext);

  const [fields, setFields] = useState<WorkOrderField[]>([]);
  const [getWorkOrderTemplate, { data: workOrderTemplateData }] = useLazyQuery(
    GET_WORK_ORDER_TEMPLATE,
  );

  useEffect(() => {
    if (workOrderTemplateData) {
      setFields(workOrderTemplateData.workOrderTemplate.fields);
    }
  }, [workOrderTemplateData]);

  useEffect(() => {
    if (workOrdersInputCart.workTemplateIds.length === 1) {
      getWorkOrderTemplate({
        variables: {
          id: workOrdersInputCart.workTemplateIds.join(''),
        },
      });
    } else if (workOrdersInputCart.workTemplateIds.length !== 1) {
      setFields(null);
    }
  }, [workOrdersInputCart.workTemplateIds]);

  const onFieldFilterChange = (fieldFilter: FieldFilter) =>
    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_WORK_ORDERS_FIELD,
      data: { fieldFilter },
    });

  const getFieldFilter = (fieldId: string): FieldFilter =>
    (workOrdersInputCart.fields || []).find(field => field.id === fieldId);

  return (
    <>
      {(fields || [])
        .filter(
          field =>
            !isCascadingField(field) && isFilterableDataType(field.dataType),
        )
        .map(field => (
          <div className={classes.customFieldContainer} key={field.id}>
            <WorkOrderFieldFilterInput
              field={field}
              fieldFilter={getFieldFilter(field.id)}
              onChange={onFieldFilterChange}
              disabled={filtersDisabled}
              dataCy={`workOrdersFilterWorkField-${field.title}`}
            />
          </div>
        ))}
    </>
  );
};

export default WorkOrdersWorkFieldsFilter;
